import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import FiscalYear from "models/fiscal-year";

export interface AdminFiscalYearsSliceState {
    fiscalYears: FiscalYear[];
}

export const initialState: AdminFiscalYearsSliceState = {
    fiscalYears: [],
};

const byYearDesc = (a: FiscalYear, b: FiscalYear) => b.id - a.id;

const AdminFiscalYearsSlice = createSlice({
    name: "admin-fiscal-years-slice",
    initialState,
    reducers: {
        setFiscalYears(state, { payload }: PayloadAction<FiscalYear[]>) {
            state.fiscalYears = payload;
        },
        addFiscalYear(state, { payload }: PayloadAction<FiscalYear>) {
            state.fiscalYears = [payload, ...state.fiscalYears].sort(byYearDesc);
        },
        setFiscalYear(state, { payload }: PayloadAction<FiscalYear>) {
            const index = state.fiscalYears.findIndex(f => f.id === payload.id);
            if (index !== -1) {
                state.fiscalYears[index] = { ...state.fiscalYears[index], ...payload };
            }
        },
    },
});

export const {
    setFiscalYears,
    addFiscalYear,
    setFiscalYear,
} = AdminFiscalYearsSlice.actions;

export default AdminFiscalYearsSlice.reducer;
